import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";

export const deleteExternalTeacher = createAsyncThunk<void, string, { extra: Partial<Dependencies> }>(
  "educationalAdvisor/externalTeacher/delete",
  async (id, { extra: { educationalAdvisorRepository } }) => {
    await educationalAdvisorRepository!.deleteExternalTeacher(id);
  },
);

export const resetDeleteExternalTeacher = createAction("educationalAdvisor/externalTeacher/resetDelete");
